import { useEffect, useState } from 'react';
import AuthService from '../../api/authService';
import LoginPage from '.';
import React from 'react';

interface RequireAuthProps {
  children: React.ReactNode;
}

export const RequireAuth = ({ children }: RequireAuthProps) => {
  const [login, setLogin] = useState<boolean | undefined>(undefined);

  const authCallback = (result: boolean) => {
    setLogin(result);
  };

  useEffect(() => {
    const auth = async () => {
      const result = await AuthService.verify();
      setLogin(result);
    };

    auth();
  }, []);

  if (login === undefined) {
    return null;
  }

  if (!login) {
    return <LoginPage callback={authCallback} />;
  }

  return <>{children}</>;
};
